import ApiService from '../../../../../../../services/ApiService'

export default {
  props: {
    serviceOrder: Object,
    newChecklist: Boolean,
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    if (!this.newChecklist) {
      const checklistTemplate = this.serviceOrder.checklistServiceOrders.map(
        (checklist) => {
          return checklist.checklistTemplate
        }
      )

      this.templates = checklistTemplate.map((template) => {
        return template
      })
    } else {
      this.standardEquipmentId = this.serviceOrder.equipment.standardEquipmentId
      this.getTemplates()
    }
  },

  data: () => ({
    templateLoading: false,
    loading: false,
    firstValid: true,
    error: false,
    errorMessage: '',
    standardEquipmentId: null,
    institutionId: null,
    templateSelected: {},
    templates: [],
    templateItems: [],
    apiService: new ApiService(),
  }),

  computed: {},

  methods: {
    close() {
      this.$emit('close')
    },

    async getTemplates() {
      this.templateLoading = true
      const templateListModel = {
        StandardEquipmentId: this.standardEquipmentId,
        InstitutionId: this.institutionId,
      }
      await this.apiService
        .post(`checklistTemplate/listByEquipment`, templateListModel)
        .then((response) => {
          this.templates = response.content
        })
        .catch((err) => {
          this.errorMessage = err.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.templateLoading = false
    },

    getTemplateItems() {
      if (!this.templateSelected.checklistTemplate) return

      this.templateItems = this.templateSelected.checklistTemplate.templateItems
    },

    visualizeChecklist() {
      this.openChecklist()
    },

    async openChecklist() {
      this.close()
      const checklist = {
        ChecklistTemplate: this.templateSelected,
        ServiceOrderId: this.serviceOrder.id,
        EquipmentId: this.serviceOrder.equipmentId,
      }
      sessionStorage.setItem('checklist', JSON.stringify(checklist))
      const route = this.$router.resolve({ path: '/bigData-formChecklist' })
      window.open(route.href, '_blank')
    },

    async addTemplateItems() {
      this.loading = true
      if (this.templateItems.length > 0) {
        const checklistServiceOrder = {
          TemplateId: this.templateSelected.id,
          ServiceOrderId: this.serviceOrder.id,
          TemplateItems: this.templateItems,
        }

        await this.apiService
          .post('checklistServiceOrder/add', checklistServiceOrder)
          .then((response) => {
            if (response.statusCode == 200) {
              this.openChecklist()
              this.loading = false
            }
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
            this.loading = false
          })
      }
    },

    async submit() {
      this.loading = true

      const serviceOrder = {
        Id: this.serviceOrder.id,
        ChecklistTemplateId: this.templateSelected.checklistTemplateId,
      }

      await this.apiService
        .post('serviceOrder/setTemplate', serviceOrder)
        .then((response) => {
          this.addTemplateItems()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },
  },

  watch: {},
}
